import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing" }
const _hoisted_2 = { class: "card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30" }
const _hoisted_3 = { class: "card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 mb-4" }
const _hoisted_4 = { class: "table-responsive table-scroll-mobile" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  class: "modal fade",
  id: "addShopifyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_15 = { class: "modal-content p-15 p-md-40" }
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = { class: "modal-title fs-5" }
const _hoisted_18 = { class: "modal-body" }

import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import moment from "moment";
import Swal from "sweetalert2";
import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddShopify',
  setup(__props) {

const stores = ref<any[]>([]);
const showModal = ref(false);
const editing = ref(false);
const editId = ref<number | null>(null);

const { showToast } = useAppToast();

const form = ref({
  shopify_name: "",
  shopify_domain: "",
  shopify_secret: "",
});

const loadStores = async () => {
  const { data } = await api.get("/api/auth/client/shopify");
  stores.value = data.data;
};

onMounted(loadStores);

const openModal = (store: any = null) => {
  editing.value = !!store;

  if (store) {
    editId.value = store.id;
    form.value = { ...store };
  } else {
    editId.value = null;
    form.value = { shopify_name: "", shopify_domain: "", shopify_secret: "" };
  }

  const modalEl = document.getElementById("addShopifyModal");
  if (modalEl) {
    const modal = new Modal(modalEl);
    showModal.value = true;

    modal.show();
  }
};

const submit = async () => {
  try {
    let res;

    if (editing.value && editId.value) {
      res = await api.put(
        `/api/auth/client/shopify/${editId.value}`,
        form.value
      );

      if (res.data && res.data.success) {
        showToast("Store modifié avec succès", "success");
        closeModal();
        await loadStores();
      } else if (res.data && res.data.success === false) {
        showToast(
          res.data.message ?? "Erreur lors de la modification du store",
          "error"
        );
      }
    } else {
      res = await api.post("/api/auth/client/shopify", form.value);
      if (res.data && res.data.success) {
        showToast("Store ajouté avec succès", "success");
        closeModal();
        await loadStores();
      } else if (res.data && res.data.success === false) {
        console.log("Response error:", res);
        showToast(
          res.data.message ?? "Erreur lors de l'ajout du store",
          "error"
        );
      }
    }

    console.log("Response:", res);
  } catch (error) {
    console.error("Submit error:", error);

    // optional: show toast / alert
    // showToast(error.response?.data?.message || "Something went wrong", "error");
  }
};

const removeStore = async (id: number) => {
  Swal.fire({
    text: "Vous voulez supprimer ce store ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimer!",
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      await api.delete(`/api/auth/client/shopify/${id}`);
      loadStores();
    }
  });
};

function getDate(value) {
  if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
  else return "";
}

const addShopifyModal = ref<HTMLElement | null>(null);
let modalInstance: Modal | null = null;

onMounted(() => {
  // if (addShopifyModal.value) {
  //   modalInstance = new Modal(addShopifyModal.value, {
  //     backdrop: "static",
  //     keyboard: false,
  //   });
  // }
});

const closeModal = () => {
  // modalInstance?.hide();
  console.log("Closing modal");
  // const modalEl = document.getElementById("addShopifyModal");
  // console.log("Modal element:", modalEl);
  // if (modalEl) {
  //   const modal = new Modal(modalEl);
  //   modal.hide();
  // }

  const modalEl = document.getElementById("addShopifyModal");
  const instance = Modal.getInstance(modalEl);
  instance?.hide();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal()))
          }, " + Lier un store ")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg-gray-100" }, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Store "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Domain "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Webhook URL "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Actions ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stores.value, (s) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: s.id
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(s.shopify_name), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("a", {
                      href: s.shopify_domain,
                      target: "_blank"
                    }, _toDisplayString(s.shopify_domain), 9, _hoisted_8)
                  ]),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(s.shopify_key), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(getDate(s.created_at)), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-danger",
                      onClick: ($event: any) => (removeStore(s.id))
                    }, " 🗑 ", 8, _hoisted_12)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h1", _hoisted_17, _toDisplayString(editing.value ? "Modifier store" : "Ajouter store"), 1),
            _createElementVNode("button", {
              class: "btn-close",
              onClick: closeModal
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.shopify_name) = $event)),
              class: "form-control mb-3",
              placeholder: "Nom du store"
            }, null, 512), [
              [_vModelText, form.value.shopify_name]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.shopify_domain) = $event)),
              class: "form-control mb-3",
              placeholder: "Domain"
            }, null, 512), [
              [_vModelText, form.value.shopify_domain]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.shopify_secret) = $event)),
              class: "form-control mb-3",
              placeholder: "Webhook secret"
            }, null, 512), [
              [_vModelText, form.value.shopify_secret]
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: closeModal
            }, "Annuler"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: submit
            }, "Appliquer")
          ])
        ])
      ])
    ])
  ], 64))
}
}

})